<script setup lang="ts">
// TODO:
export interface BaseLink {
  title: string;
  imageUrl?: string;
  href: string;
}
const props = defineProps<BaseLink>();
const color = useColorMode();
</script>

<template>
  <BaseButton
    link
    type="secondary"
    :name="props.title"
    tag="nuxt-link"
    :to="props.href"
  >
    <div class="flex items-center gap-2">
      <BaseLogo :src="props.imageUrl" with-initials with-border :title="props.title" :no-background="color.value !== 'dark'" />
      <p class="line-clamp-2 text-secondary">
        {{ props.title }}
      </p>
    </div>
  </BaseButton>
</template>
